module.exports = ".alert.alert-ok {\n  height: 26px;\n  background: rgba(0, 128, 0, 0.568);\n  width: 8%;\n  padding: 0;\n  color: #fff;\n  float: right;\n  margin: -40px 51px 51px 607px;\n  border-radius: 0px;\n  text-align: center; }\n\n.alert.alert-ko {\n  height: 26px;\n  background: #db1e4ec7;\n  width: 8%;\n  padding: 0;\n  color: #fff;\n  float: right;\n  margin: -40px 51px 51px 607px;\n  border-radius: 0px;\n  text-align: center; }\n\n.text-uppercase {\n  text-transform: uppercase !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form-landing/form-landing.component.scss
// module id = ./src/app/form-landing/form-landing.component.scss
// module chunks = main